<template>
  <div>
    <span class="invisible">{{ job.id }}</span>
    <a href="#" @click.prevent="handleEdit">{{ job.name }}</a>
    <el-tooltip v-if="job.description" class="item" effect="dark" :content="viewDescriptionNoHtml" placement="right-end">
      <img class="icon-help m-left-4" src="static/img/icon-info.png" />
    </el-tooltip>
  </div>
</template>

<script>
import {stripHTML} from 'src/utilities/utils'

export default {
  props: ['data'],
  computed: {
    job() {
      if (!this.data) {
        console.error("'data' prop must contain a search result row. It is missing and is required")
        return {}
      }
      return this.data
    },
    viewDescriptionNoHtml() {
      return stripHTML(this.job.description)
    }
  },
  methods: {
    handleEdit() {
      this.$eventHub.$emit('show-modal-1', 'Edit Job', {id: this.job.id}, '80%')
    }
  }
}
</script>
